
import piModelAdd from "./components/pi-model-add.vue";
import editPassword from "./components/edit-password.vue";
import piExportEquipment from "./components/pi-export-equipment.vue";
import { getOptionList, optionKey } from "@/api/api-dict";
import piListDetail from "./components/pi-list-detail.vue";
import piListMatch from "./components/pi-list-match.vue";
import piselectStation from "@/components/select-station/select-station.vue";
import piSelectOper from "@/components/select-oper/select-oper.vue";
import { Component, Vue } from "vue-property-decorator";
import i18n from "@/config/i18n";
import {
  getModelList,
  getDevicePageList,
  delBatch,
  unbindOperBatch,
  getDeviceCout
} from "@/api/api-basic";

import { objAny } from "@/common/common-interface";

@Component({
  components: {
    "pi-model-add": piModelAdd,
    "pi-list-detail": piListDetail,
    editPassword: editPassword,
    "pi-list-match": piListMatch,
    "pi-select-station": piselectStation,
    "pi-select-oper": piSelectOper,
    "pi-export-equipment": piExportEquipment
  }
})
export default class EquipmentList extends Vue {
  private piModelAdd: objAny = {};
  private editPassword: objAny = {};
  private piExportEquipment: objAny = {};
  private devTypeList: object[] = [];

  private piListDetail: objAny = {}; // 弹框
  private piListMatch: objAny = {}; // 弹框
  private modelList: object[] = [];
  private oprList: object[] = [];
  private privilege: objAny = {}; // 权限
  private totalCout: objAny = {}; // 关联未关联的设备统计

  private isBindOperList: objAny = [
    { key: "", label: i18n.t("all"), disabled: false },
    { key: "0", label: i18n.t("equipmentList.unattached"), disabled: false },
    { key: "1", label: i18n.t("equipmentList.attached"), disabled: false }
  ];
  private stationList = [];
  private total = 0;
  private loading = false;
  private selectList: object[] = [];
  private maintenanceMethodsTypeList: object[] = [];

  private formInline: objAny = {
    deviceModelPkId: "",
    globalOrder: "",
    globalSearch: "",
    isBindOper: "",
    oprPkId: "",
    sns: "",
    staPkId: "",
    projectName: "",
    maintenanceMethodsType: "",
    globalPageIndex: 1,
    globalPageSize: 10
  };
  private ruleInline = {};
  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      type: "selection",
      width: 60,
      align: "center"
    },
    {
      title: i18n.t("equipmentList.serialNumber"),
      key: "serialNumber",
      resizable: true,
      minWidth: 130
    },
    {
      title: i18n.t("equipmentModel.deviceModelName"),
      key: "deviceModelName",
      resizable: true,
      minWidth: 130
    },
    {
      title: i18n.t("equipmentModel.deviceType"),
      key: "deviceTypeName",
      resizable: true,
      minWidth: 130
    },
    {
      title: i18n.t("equipmentList.gunNum"),
      key: "gunNum",
      resizable: true,
      minWidth: 60
    },
    {
      title: i18n.t("equipmentModel.standard"),
      key: "spec",
      resizable: true,
      minWidth: 120,
      slot: "spec"
    },
    {
      title: i18n.t("equipmentModel.matching"),
      key: "equipmentType",
      resizable: true,
      minWidth: 80,
      slot: "matchingOptions"
    },
    {
      title: i18n.t("equipmentList.belongInfo"),
      resizable: true,
      minWidth: 90,
      slot: "staName"
    },
    {
      title: i18n.t("equipmentList.projectName"),
      key: "projectName",
      minWidth: 120
    },
    {
      title: i18n.t("equipmentList.maintenanceMethodsType"),
      key: "maintenanceMethodsDesc",
      minWidth: 100
    },
    {
      title: i18n.t("equipmentList.lastSuccessful"),
      key: "passwordChangeTime",
      minWidth: 100
    },
    {
      title: i18n.t("operation"),
      key: "userName",
      resizable: true,
      minWidth: 60,
      slot: "action"
    }
  ];
  private isUnBind = true;
  private isBind = true;
  public selectItem(list: object[]) {
    this.selectList = list;
    if (list.length > 0) {
      let isUnBind = false;
      let isBind = false;
      list.map((item: objAny) => {
        if (item.oprPkId) {
          isBind = true;
        }
        if (!item.oprPkId) {
          isUnBind = true;
        }
      });
      this.isUnBind = isUnBind;
      this.isBind = isBind;
    } else {
      this.isUnBind = true;
      this.isBind = true;
    }
  }
  public queryEquipment(): void {
    const deviceSns: string[] = [];
    this.selectList.map((item: objAny) => {
      deviceSns.push(item.pilePkId);
    });
    this.unbindClick({ deviceSns: deviceSns });
  }
  public delItem() {
    const deviceSns: string[] = [];
    this.selectList.map((item: objAny) => {
      deviceSns.push(item.pilePkId);
    });
    this.delEquipment({ deviceSns: deviceSns });
  }
  // 批量关联
  public bindClick(): void {
    this.piListMatch.open(this.selectList, "oper");
  }
  // 批量更换型号
  public changeModel(): void {
    this.piListMatch.open(this.selectList, "devType");
  }

  public operChange(val: number | string) {
    this.formInline.oprPkId = val;
  }
  public stationChange(val: number | string) {
    this.formInline.staPkId = val;
  }

  public sortChange(column: objAny): void {
    if (column.order === "normal") {
      this.formInline.globalOrder = "";
    } else {
      this.formInline.globalOrder =
        "name=" + column.key + ",age=" + column.order;
    }
    this.getTableList();
  }

  public queryClick(): void {
    this.formInline.globalPageIndex = 1;
    this.getTableList();
  }
  public pageChange(val: number): void {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public sizeChange(val: number): void {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }

  public detailBtn(item: objAny, index: number): void {
    this.piListDetail.open(item, index);
  }
  public operSuccess(list: object[]): void {
    this.oprList = list;
  }
  public bindSuccess(): void {
    this.getDeviceCoutData();
    this.getTableList();
  }

  async getTableList(): Promise<void> {
    this.loading = true;
    const json = JSON.parse(JSON.stringify(this.formInline));
    if (this.formInline.sns != "") {
      json.sns = this.formInline.sns.split(",");
    } else {
      json.sns = [];
    }

    const ret = await getDevicePageList(json);
    if (ret.status === this.$config.apiStatus) {
      this.total = ret.total;
      this.tableList = ret.data;
      this.selectItem([]);
    }
    this.loading = false;
  }
  // 获取设备型号
  async getModelList(): Promise<void> {
    const ret = await getModelList({});
    if (ret.status === this.$config.apiStatus) {
      this.modelList = ret.data;
    }
  }
  // 批量删除
  async delEquipment(formData: objAny): Promise<void> {
    const ret = await delBatch(formData);
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("deleteSuccess"));
      this.getTableList();
      this.getDeviceCoutData();
    }
  }

  // 批量解绑
  async unbindClick(formData: objAny): Promise<void> {
    const ret = await unbindOperBatch(formData);
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess"));
      this.getTableList();
      this.getDeviceCoutData();
    }
  }
  // 获取设备统计
  async getDeviceCoutData(): Promise<void> {
    const ret = await getDeviceCout({});
    if (ret.status === this.$config.apiStatus) {
      this.totalCout = ret.data[0] || {};
    }
  }

  public created(): void {
    this.getDeviceCoutData();
    this.getModelList();
  }
  public addEquipment(): void {
    this.piModelAdd.open();
  }
  public editPwd(): void {
    this.editPassword.open(this.selectList);
  }
  public exportEquipment(): void {
    this.piExportEquipment.open();
  }

  async getOptionList() {
    const ret = await getOptionList([
      optionKey.devTypeList,
      optionKey.maintenanceMethodsType
    ]); //请求字典
    this.devTypeList = ret[optionKey.devTypeList]; // 客户名称
    this.maintenanceMethodsTypeList = ret[optionKey.maintenanceMethodsType]; // 维护方式
  }
  mounted() {
    this.$nextTick((): void => {
      this.piModelAdd = this.$refs["piModelAdd"];
      this.piListDetail = this.$refs["piListDetail"];
      this.editPassword = this.$refs["editPassword"];
      this.piListMatch = this.$refs["piListMatch"];
      this.piExportEquipment = this.$refs["piExportEquipment"];
    });
    this.privilege = this.$route.meta.privilegeVoObj;
    this.getOptionList();
  }
  activated() {
    const oprPkId = this.$common.request("oprPkId");
    if (oprPkId != "") {
      this.formInline.oprPkId = oprPkId;
      this.formInline.deviceModelPkId = "";
      this.formInline.globalOrder = "";
      this.formInline.globalSearch = "";
      this.formInline.isBindOper = "";
      this.formInline.staPkId = "";
      this.formInline.sns = "";

      this.queryClick();
    } else if (this.tableList.length == 0) {
      this.queryClick();
    }
  }
}
